import script from "./StatusNotificationManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusNotificationManagement.vue?vue&type=script&setup=true&lang=js"

import "./StatusNotificationManagement.vue?vue&type=style&index=0&id=36824237&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36824237"]])

export default __exports__